<template>
  <gw-listing :title="$t('Indicador')" :entityDtoRestResource="indicadorRestResource"
  :presentation="presentation"
  :rowActionsColumnSize="190">

    <gw-column field="status"/>
    <gw-column field="nome"/>
    <gw-column field="versaoSistema"/>
    <gw-column field="desempenhoMinimo"/>
    <gw-column field="desempenhoMaximo"/>
    <gw-column field="desempenhoMelhor"/>
    <gw-column field="medicaoTipoResultado"/>
    <gw-column field="medicaoUnidadeMedida"/>
    <gw-column field="medicaoTipoUnidadeNegocio"/>
    <gw-column field="medicaoIntervaloEmMinutos"/>
    <gw-column field="medicaoAceitaResultadoNulo"/>

    <template slot="rowActions" slot-scope="{entity}">
      <gw-action :name="$t('Indicador.ui.actionConsultas')" @actionPerformed="abrirConsultas(entity)"/>
    </template>

    <template slot="filterBand">
      <gw-possible-value-filter-item :display-text="$t('Indicador.ui.filtroStatus')"
        property-name="status" :possibleValues="statusPossibleValues"/>
      <a7-classificacao-indicador-filter-item :display-text="$t('Indicador.ui.filtroDepartamento')"
        property-name="classificacaoDepartamento" :tipo="classificacaoIndicadorConstants.TIPO_DEPARTAMENTO"/>
      <a7-classificacao-indicador-filter-item :display-text="$t('Indicador.ui.filtroGestao')"
        property-name="classificacaoGestao" :tipo="classificacaoIndicadorConstants.TIPO_GESTAO"/>
      <a7-classificacao-indicador-filter-item :display-text="$t('Indicador.ui.filtroRamoAtividade')"
        property-name="classificacaoRamoAtividade" :tipo="classificacaoIndicadorConstants.TIPO_RAMOATIVIDADE"/>
      <a7-classificacao-indicador-filter-item :display-text="$t('Indicador.ui.filtroInvestimento')"
        property-name="classificacaoInvestimento" :tipo="classificacaoIndicadorConstants.TIPO_INVESTIMENTO"/>

      <gw-text-filter-item :display-text="$t('Indicador.ui.filtroNome')" property-name="nome"/>
      <gw-text-filter-item :display-text="$t('Indicador.ui.filtroVersaoSistema')"
        property-name="versaoSistema"/>
    </template>

    <template slot="editor">
      <gw-grouping-pane :title="$t('Global.ui.detalhes')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="nome" class="gw-col-6"/>
            <gw-editor-field property="status" class="gw-col-3"/>
            <gw-editor-field property="versaoSistema" class="gw-col-3"/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
      <gw-grouping-pane :title="$t('Indicador.ui.classificacao')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="classificacaoDepartamento" class="gw-col-12">
              <a7-classificacao-indicador-entity-chooser
                slot-scope="{ entity, properties }"
                v-model="entity.classificacaoDepartamento"
                v-bind="properties"
                :tipo="classificacaoIndicadorConstants.TIPO_DEPARTAMENTO" folha/>
            </gw-editor-field>
            <gw-editor-field property="classificacaoGestao" class="gw-col-12">
              <a7-classificacao-indicador-entity-chooser
                slot-scope="{ entity, properties }"
                v-model="entity.classificacaoGestao"
                v-bind="properties"
                :tipo="classificacaoIndicadorConstants.TIPO_GESTAO" folha/>
            </gw-editor-field>
            <gw-editor-field property="classificacaoRamoAtividade" class="gw-col-12">
              <a7-classificacao-indicador-entity-chooser
                slot-scope="{ entity, properties }"
                v-model="entity.classificacaoRamoAtividade"
                v-bind="properties"
                :tipo="classificacaoIndicadorConstants.TIPO_RAMOATIVIDADE" folha/>
            </gw-editor-field>
            <gw-editor-field property="classificacaoInvestimento" class="gw-col-12">
              <a7-classificacao-indicador-entity-chooser
                slot-scope="{ entity, properties }"
                v-model="entity.classificacaoInvestimento"
                v-bind="properties"
                :tipo="classificacaoIndicadorConstants.TIPO_INVESTIMENTO" folha/>
            </gw-editor-field>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
      <gw-grouping-pane :title="$t('Indicador.ui.medicoes')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="medicaoTipoResultado" class="gw-col-6"/>
            <gw-editor-field property="medicaoUnidadeMedida" class="gw-col-6"/>
            <gw-editor-field property="medicaoTipoUnidadeNegocio" class="gw-col-6"/>
            <gw-editor-field property="medicaoIntervaloEmMinutos" class="gw-col-6"/>
            <gw-editor-field property="medicaoAceitaResultadoNulo" class="gw-col-12"/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
      <gw-grouping-pane :title="$t('Indicador.ui.desempenho')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="desempenhoMelhor" class="gw-col-12"/>
            <gw-editor-field property="desempenhoMinimo" class="gw-col-6"/>
            <gw-editor-field property="desempenhoMaximo" class="gw-col-6"/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
      <gw-grouping-pane :title="$t('Indicador.ui.dicionario')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="objetivo" class="gw-col-12"/>
            <gw-editor-field property="procedimento" class="gw-col-12"/>
            <gw-editor-field property="risco" class="gw-col-12"/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
    </template>
  </gw-listing>
</template>

<script>
import {
  GwListing,
  GwColumn,
  GwTextFilterItem,
  GwPossibleValueFilterItem,
  GwGroupingPane,
  GwGridContainer,
  GwEditorField,
  GwAction,
  DefaultExceptionHandler,
  FilterUtilities
} from 'guaxinim-web';
import IndicadorRestResource from './IndicadorRestResource';
import A7ClassificacaoIndicadorFilterItem
  from  '../classificacaoIndicador/A7ClassificacaoIndicadorFilterItem';
import A7ClassificacaoIndicadorEntityChooser
  from  '../classificacaoIndicador/A7ClassificacaoIndicadorEntityChooser';
import ClassificacaoIndicadorConstants
  from  '../classificacaoIndicador/ClassificacaoIndicadorConstants';

export default {
  name: 'a7-indicador-listing',
  components: {
    GwListing,
    GwColumn,
    GwTextFilterItem,
    GwPossibleValueFilterItem,
    GwGroupingPane,
    GwGridContainer,
    GwEditorField,
    GwAction,
    A7ClassificacaoIndicadorEntityChooser,
    A7ClassificacaoIndicadorFilterItem
  },
  data() {
    return {
      indicadorRestResource: IndicadorRestResource,
      presentation: null,
      classificacaoIndicadorConstants: ClassificacaoIndicadorConstants
    }
  },
  computed: {
    statusPossibleValues() {
      if (!this.presentation) return [];
      return this.presentation.properties.status.possibleValues;
    }
  },
  methods: {
    abrirConsultas(indicador) {
      this.$router.push({name: 'indicadorconsulta', params: {indicador}})
    }
  },
  created() {
    this.indicadorRestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch(err => this.$gw.defaultExceptionHandler.handleUnknowException(err, this))
  }
}
</script>

<style>

</style>
